export const Sentiments =
    [
        'Extremely Negative',
        'Very Strong Negative',
        'Strong Negative',
        'Mild Negative',
        'Neutral',
        'Mild Positive',
        'Strong Positive',
        'Very Strong Positive',
        'Extremely Positive'
    ];
